import {
  createMigrate,
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import appSliceReducer, { AppState, initialState } from './slices/app'
import { PersistConfig } from 'redux-persist/es/types'

interface StoreState {
  app: AppState
}

const migrations = {
  2: (state: any) => {
    return {
      ...state,
      app: {
        ...state.app,
        disclaimers: {},
      },
    }
  },
  3: (state: any) => {
    return {
      ...state,
      app: {
        ...initialState,
      },
    }
  },
  // Large structure changes with addresses, so was easier to reset store
  4: (state: any) => {
    return {
      ...state,
      app: {
        ...initialState,
      },
    }
  },
  // Structure changes with transfer provider, so was easier to reset store
  5: (state: any) => {
    return {
      ...state,
      app: {
        ...initialState,
      },
    }
  },
}

const persistConfig: PersistConfig<StoreState> = {
  key: 'app',
  version: 5,
  storage,
  migrate: createMigrate(migrations, { debug: true }),
}

const rootReducer = combineReducers({ app: appSliceReducer })

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
